import { BASE_NODE } from "../../utils/constants";

export const SHOPPING_NODE = `${BASE_NODE}/shopping`;
